export default "__VITE_ASSET__4tlP1wNR__"